import request from "@/utils/request";

export function login(data) {
  return request({
    url: "/api/admin/login",
    method: "post",
    data,
    showError: false,
  });
}

export function getProfile() {
  return request({
    url: "/api/admin/profile",
    method: "get",
    skipAuthRedirect: true,
  });
}
